module.exports = __webpack_public_path__ + "img/the-netherlands-stomach-cancer-male.cd0f5007.png";